import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CmsManagementService } from "src/app/modules/cms-management/services/cms-management.service";
import { PopupService } from "../../popup/popup.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { EnglishLettersAndNumbersOnly } from "src/app/core/helpers/English-Letters-And-Numbers-Only.validator";
import { ArabicLettersAndNumbersOnly } from "src/app/core/helpers/Arabic-Letters-And-Numbers-Only.validator";
import { Subject } from "rxjs";
import { HttpHandlerService } from "src/app/core/services/http-handler.service";
import { ToastrService } from "ngx-toastr";
import { finalize, takeUntil } from "rxjs/operators";
import { Config } from "src/app/core/config/api.config";
import { TranslationModuleEnum } from "../../../utils/translation-modules.enum";

@Component({
  selector: "app-cms-mode-title-customizer",
  templateUrl: "./cms-mode-title-customizer.component.html",
  styleUrls: ["./cms-mode-title-customizer.component.scss"],
})
export class cmsModeTitleCustomizer implements OnInit, AfterViewInit {
  private endSub$ = new Subject();
  translationModulesEnum = TranslationModuleEnum;
  cmsMode = this.cmsManagementService.getCMSMode();
  cmsModeForm: FormGroup;
  sendingLoading: boolean = false;
  isSubmitFormDisabled: boolean = true;
  formOldData: any;

  @Input() lang: string;
  @Input() selectedTranslationObj: any;

  constructor(
    private cmsManagementService: CmsManagementService,
    private popupSer: PopupService,
    private fb: FormBuilder,
    private translate: TranslateService,
    private httpSer: HttpHandlerService,
    private toaster: ToastrService
  ) {}

  ngOnInit(): void {
    this.initCmsModeForm();
  }

  ngAfterViewInit() {
    this.patchCmsModeForm();
  }
  // setTranslationToObject(){
  //   let mergedTranslationFIle = JSON.parse(sessionStorage.getItem('translation_file_mergedTranslations'))
  //   let moduleName = this.selectedTranslationObj.translationKey.split('.')[0]
  //   let translationKey = this.selectedTranslationObj.translationKey.split('.')[1]
  //   mergedTranslationFIle['en'][moduleName][translationKey] = 'test'
  //   //
  //   console.log(mergedTranslationFIle['en'][moduleName][translationKey]);
  //   console.log(mergedTranslationFIle['en']);
  //   this.translate.setTranslation('en', mergedTranslationFIle['en'], true)
  //   this.changeDetectorRef.detectChanges()
  // }
  // findKeyInObject(obj: any, keyToFind: string): any {
  //   // Ensure the object is not null and is of type object
  //   if (obj !== null && typeof obj === 'object') {
  //     // Iterate over object keys
  //     for (const key of Object.keys(obj)) {
  //       // If the current key is the one we're looking for, return its value
  //       if (key === keyToFind) {
  //         return obj[key];
  //       }
  //
  //       // If the value is an object, recurse into it
  //       const result = this.findKeyInObject(obj[key], keyToFind);
  //       if (result !== undefined) {
  //         return result;
  //       }
  //     }
  //   }
  //   // Return undefined if the key isn't found
  //   return undefined;
  // }
  initCmsModeForm() {
    this.cmsModeForm = this.fb.group({
      titleEn: [null, [Validators.required, EnglishLettersAndNumbersOnly()]],
      titleAr: [null, [Validators.required, ArabicLettersAndNumbersOnly()]],
    });
  }

  patchCmsModeForm() {
    if (this.selectedTranslationObj?.selectedValueForTranslation) {
      this.cmsModeForm.patchValue({
        titleEn: this.selectedTranslationObj?.selectedValueForTranslation?.en,
        titleAr: this.selectedTranslationObj?.selectedValueForTranslation?.ar,
      });
    }
  }

  checkFormValid(event) {
    const oldTitleEn =
      this.selectedTranslationObj?.selectedValueForTranslation?.en;
    const oldTitleAr =
      this.selectedTranslationObj?.selectedValueForTranslation?.ar;
    const newTitleEn = this.addFormControls.titleEn.value;
    const newTitleAr = this.addFormControls.titleAr.value;
    if (oldTitleEn != newTitleEn || oldTitleAr != newTitleAr) {
      this.isSubmitFormDisabled = false;
    }
  }

  setFormOldData() {
    this.cmsModeForm.patchValue({
      titleEn: this.formOldData.title,
      titleAr: this.formOldData.arabicTitle,
    });
  }

  get formGroup() {
    return this.cmsModeForm;
  }

  get addFormControls() {
    return this.cmsModeForm.controls;
  }

  saveFormData() {
    let formDataObject: any = {
      searchKey: this.selectedTranslationObj.translationKey,
      module: this.selectedTranslationObj.translationModuleEnum,
      valueEn: this.addFormControls.titleEn.value,
      valueAr: this.addFormControls.titleAr.value,
    };

    this.submitForm(formDataObject);
  }

  submitForm(body) {
    this.sendingLoading = true;
    this.httpSer
      .post(`${Config.Translation.Set}`, body)
      .pipe(
        finalize(() => {
          setTimeout(() => {
            this.closeModal();
          }, 500);
        }),
        takeUntil(this.endSub$)
      )
      .subscribe(
        res => {
          this.showTranslatedToaster("success", "shared.cmsSuccessMessage");
          //this.refreshCurrentPage(500);
          this.updateKey(body);
        },
        error => {
          // You can access status:
          console.error(error);
          this.showTranslatedToaster("error", "shared.somethingWentWrong");
        }
      );
  }

  closeModal() {
    this.cmsManagementService.selectedTranslationObj.next(null);
    this.popupSer.close();
    this.sendingLoading = false;
  }

  // updateKey(data) {
  //   console.log('data ', data);
  //   this.translate.getTranslation('en').subscribe(res => {
  //     console.log('res ', res);
  //     this.translate.setTranslation(this.translate.currentLang, res)
  //   })
  // }
  updateKey(data: any) {
    // update session translation objects
    const mergedTranslationFile = JSON.parse(
      sessionStorage.getItem("translation_file_mergedTranslations")
    ) || { en: {}, ar: {} };

    // update session translation objects
    this.updateObject(mergedTranslationFile.en, data.searchKey, data.valueEn);
    this.updateObject(mergedTranslationFile.ar, data.searchKey, data.valueAr);
    sessionStorage.setItem(
      "translation_file_mergedTranslations",
      JSON.stringify(mergedTranslationFile)
    );
    this.translate.setTranslation(
      this.lang,
      mergedTranslationFile[this.lang],
      true
    );
    this.translate.use(this.lang);
  }

  updateObject(obj: any, path: any, newValue: any) {
    const keys = path.split(".");
    let currentObj = obj;

    for (let i = 0; i < keys.length - 1; i++) {
      if (!currentObj[keys[i]]) {
        // If the path doesn't exist, return or handle the error as needed
        return;
      }
      currentObj = currentObj[keys[i]];
    }

    // Update the value of the last key
    const lastKey = keys[keys.length - 1];
    currentObj[lastKey] = newValue;

    return obj;
  }

  refreshCurrentPage(timeout: number = 250): void {
    setTimeout(() => {
      window.location.reload();
    }, timeout);
  }

  showTranslatedToaster(toasterType, msg) {
    if (toasterType === "success") {
      this.toaster.success(this.translate.instant(msg));
    }
    if (toasterType === "error") {
      this.toaster.error(this.translate.instant(msg));
    }
  }

  ngOnDestroy(): void {
    this.endSub$.next(null);
    this.endSub$.complete();
  }
}
